var map = {
	"./theme_blue/ic_exchange_actived.svg": "378c",
	"./theme_cyan/ic_exchange_actived.svg": "8735",
	"./theme_purple/ic_exchange_actived.svg": "ccbb",
	"./theme_red/ic_exchange_actived.svg": "9229",
	"./theme_yellow/ic_exchange_actived.svg": "1175"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f69";